'use client';
import { useState, useEffect } from 'react';
import WindowSize from '@/utils/windowSize';
import Container from '@/components/layout/Container';
import Headings from '@/components/heading/Headings';
import DonationCounter from './DonationCounter';

export default function DonationBanner({ block, position }) {
  const windowSize = WindowSize();
  const [scroll, setScroll] = useState(false);
  const [viewed, setViewed] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const section = document.getElementById(`${block.uid}_${position}`);
      if (section) {
        const bounding = section.getBoundingClientRect();
        if (
          !viewed &&
          bounding.top < window.innerHeight &&
          bounding.bottom > 0
        ) {
          setScroll(true);
          setViewed(true); // Ensure it only triggers once
        }
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [viewed, block.uid, position]);

  return (
    <section
      id={`${block.uid}_${position}`}
      data-name="donation_banner"
      className={`donation_banner px-5 py-20 sm:px-10 lg:px-[120px] lg:py-[120px] ${block.background_color_picker ? `bg-[${block.background_color_picker}]` : ''}`}
    >
      <Container fullPage={false}>
        <div className="max-w-container sm:flex">
          {windowSize.width >= 640 && (
            <div className="self-center">
              <div
                className={`donation_counter flex flex-row text-center ${scroll ? 'visible' : ''}`}
              >
                <DonationCounter
                  block={block.donation_count}
                  animate={scroll}
                />
              </div>
              <div className="sm:preheading-r lg:preheading-l mt-3 flex flex-row justify-center text-center uppercase lg:mt-5">
                {block.count_text}
              </div>
            </div>
          )}
          <div className="sm:ml-15 lg:ml-[120px]">
            <div className="mx-auto flex max-w-[400px] flex-row items-center sm:mx-0 sm:items-end">
              <Headings
                headingContent={
                  block.header?.length ? block.header : block.title
                }
                headingClassName="h4 lg:h2 text-center sm:text-left mx-auto sm:mx-0"
              />
            </div>
            <div className="mt-4 flex flex-row text-center sm:mt-5 sm:text-left lg:mt-10">
              <p className="body-r lg:sh8">{block.description}</p>
            </div>
          </div>
          {windowSize.width < 640 && (
            <div className="mt-15">
              <div
                className={`donation_counter flex flex-row justify-center text-center ${scroll ? 'visible' : ''}`}
              >
                <DonationCounter
                  block={block.donation_count}
                  animate={scroll}
                />
              </div>
              <div className="preheading-r mt-3 flex flex-row justify-center text-center uppercase">
                {block.count_text}
              </div>
            </div>
          )}
        </div>
      </Container>
    </section>
  );
}
